import { render } from "./AccountMultipleOutline.vue?vue&type=template&id=970e2386"
import script from "./AccountMultipleOutline.vue?vue&type=script&lang=js"
export * from "./AccountMultipleOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__